module.exports = "../../app/cells/components/discipline_banner_cell.rb";